export enum ContingencyPlanningType {
  None,
  TMS,
  CMMS,
}

export function GetContingencyPlanningTypeDisplayName(
  contingencyPlanningType: ContingencyPlanningType | undefined
) {
  if (contingencyPlanningType !== undefined)
    return ContingencyPlanningType[contingencyPlanningType];
}
